import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

const defaultActions = {
  onRefresh: null,
  onFilter: null,
  refreshing: false,
  pageTitle: null,
  pageSubtitle: null,
};

const CadastrosPageActionsContext = createContext({
  actions: defaultActions,
  setPageActions: () => {},
  clearPageActions: () => {},
});

export const CadastrosPageActionsProvider = ({ children }) => {
  const [actions, setActions] = useState(defaultActions);

  const setPageActions = useCallback((next) => {
    setActions((prev) => ({
      ...prev,
      ...next,
    }));
  }, []);

  const clearPageActions = useCallback(() => {
    setActions(defaultActions);
  }, []);

  const value = useMemo(
    () => ({ actions, setPageActions, clearPageActions }),
    [actions, setPageActions, clearPageActions]
  );

  return (
    <CadastrosPageActionsContext.Provider value={value}>
      {children}
    </CadastrosPageActionsContext.Provider>
  );
};

export const useCadastrosHeaderActions = () => {
  const { actions } = useContext(CadastrosPageActionsContext);
  return actions;
};

export const useRegisterCadastrosPageActions = ({
  onRefresh,
  onFilter,
  refreshing = false,
  pageTitle = null,
  pageSubtitle = null,
}) => {
  const { setPageActions, clearPageActions } = useContext(
    CadastrosPageActionsContext
  );

  const refreshRef = useRef(onRefresh);
  const filterRef = useRef(onFilter);
  refreshRef.current = onRefresh;
  filterRef.current = onFilter;

  const canRefresh = typeof onRefresh === "function";
  const canFilter = typeof onFilter === "function";

  useEffect(() => {
    setPageActions({
      onRefresh: canRefresh ? () => refreshRef.current?.() : null,
      onFilter: canFilter ? () => filterRef.current?.() : null,
      refreshing: Boolean(refreshing),
      pageTitle: pageTitle || null,
      pageSubtitle: pageSubtitle || null,
    });
  }, [
    canRefresh,
    canFilter,
    refreshing,
    pageTitle,
    pageSubtitle,
    setPageActions,
  ]);

  useEffect(() => () => clearPageActions(), [clearPageActions]);
};
